import { render } from "./EditIngestion.vue?vue&type=template&id=b9f9a8de"
import script from "./EditIngestion.vue?vue&type=script&lang=js"
export * from "./EditIngestion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__